import { cn } from "@/lib/utils";

/**
 * Full-width section wrapper for public pages (Home, Pricing, About).
 * Replaces .section-base / .section-alt / .section-dark patterns.
 *
 * Usage:
 *   <Section>...</Section>                          // light bg
 *   <Section variant="muted">...</Section>          // subtle off-white bg
 *   <Section variant="dark">...</Section>           // brand-800 bg, white text
 *   <Section size="lg">...</Section>                // taller padding
 *
 * Inner content should be wrapped in a PageContainer for max-width + padding.
 */
function Section({ variant = "light", size = "md", className, children }) {
  return (
    <section className={cn(
      "w-full px-4 md:px-8",
      // Vertical padding by size
      size === "sm" && "py-10 md:py-12",
      size === "md" && "py-14 md:py-20",
      size === "lg" && "py-20 md:py-28",
      // Background by variant
      variant === "light" && "bg-background",
      variant === "muted" && "bg-muted",
      variant === "dark"  && "bg-[hsl(var(--brand-800))] text-white",
      className
    )}>
      {children}
    </section>
  );
}

export { Section };
